// extracted by mini-css-extract-plugin
export default {"Container":"cyMHEolpQ_oV0XL8O1TN","Box1":"nkruD0SomdpWViS2i0yO","Box2":"xNBvHemj8Ps2aAmjO5eW","value":"eroKnPk8Rs_EG2Da1BwK","resetButton":"UaeSP7ppv9an2dx_TjAd"};